// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"StaffClientsModal_AssignChecklist__NiTev","modalBody":"StaffClientsModal_modalBody__X0NZA","formControl":"StaffClientsModal_formControl__+tWrV"};